import style from './sort-component.module.scss';
import { useEffect, useState } from 'react';
import Image from 'next/image';
interface ISortComponentProps {
  title: string;
  list: string[];
  activeValue: string;
  setActiveValue: (value: string) => void;
}

const SortComponent = ({ title, list, activeValue, setActiveValue }: ISortComponentProps) => {
  let [activeList, setListActive] = useState(false);

  useEffect(() => {
    const sortDivElement = document.getElementById(`${title}_sort`) as HTMLDivElement;
    function closeModal(event: any) {
      if (!sortDivElement.contains(event.target)) {
        setListActive(false);
      }
    }
    document.addEventListener('click', closeModal);
    return () => document.removeEventListener('click', closeModal);
  }, []);
  return (
    <div className={`${style.sort}`}>
      <div className={`${style.sort__title}`}>{title}</div>
      <div id={`${title}_sort`} className={`${style.sort__item} ${activeList ? style.sort__item_active : null}`}>
        <div
          onClick={() => setListActive(true)}
          className={`${style.sort__list_value} ${activeList ? style.sort__list_value_active : null}`}
        >
          {activeValue}
          <div className={`${style.sort__list_arrow} ${activeList ? style.sort__list_arrow_active : null}`}>
            <Image src={'/vacancies-images/icons/chevron-down.png'} width="24" height="24" alt="arrowlist" />
          </div>
        </div>
        <div className={`${style.sort__list} ${activeList ? style.sort__list_active : null}`}>
          {list.map((item: string, index: number) => {
            return (
              <div
                onClick={() => {
                  setActiveValue(item);
                  setListActive(false);
                }}
                key={index}
                className={`${style.sort__list__item} ${activeValue === item ? style.sort__list__item_active : null}`}
              >
                {item}
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default SortComponent;
